export default __webpack_public_path__ + "static/media/client2.943e0fc7.png";